import React, { Suspense } from "react";
import {
  AuthCheck,
  FirebaseAppProvider,
  useAuth,
  useFirestore,
  useFirestoreCollectionData
} from "reactfire";
import { IWave } from "../../store/types";
import firebaseConfig from "./firebaseConfig.json";

function LogInForm() {
  const auth = useAuth();
  const signIn = () => auth.signInAnonymously();
  return (
    <button type="button" className="nes-btn is-warning" onClick={signIn}>
      Sign In Anonymously
    </button>
  );
}

export function FirebaseContainer({ children }: { children: React.ReactNode }) {
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <Suspense fallback="Loading...">
        <AuthCheck fallback={<LogInForm />}>{children}</AuthCheck>
      </Suspense>
    </FirebaseAppProvider>
  );
}

export function useStoreAdders() {
  const firestore = useFirestore();
  const addData = (state: IWave) => firestore.collection("state").add(state);
  return { addData };
}

export function useStoreData() {
  // lazy load the Firestore SDK and create a collection reference
  const documentRef = useFirestore().collection("state");
  const waves: IWave[] = useFirestoreCollectionData(documentRef);
  return waves;
}
